import ProposalDetailContainer from './ProposalDetailContainer';
export default ProposalDetailContainer;
